import { render, staticRenderFns } from "./supplierAllBack.vue?vue&type=template&id=66612b44&"
import script from "./supplierAllBack.vue?vue&type=script&lang=js&"
export * from "./supplierAllBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports